export default "__VITE_ASSET__DbPE9MeV__"